module.exports = __webpack_public_path__ + "explore/images/eoy/top-publishers/tonic-2x.e50b10b1bfcc249f4dc729574cb91e94.png";